import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const YesNoChoices = [
  { label: l`client.confirm.yes`, id: true },
  { label: l`client.confirm.no`, id: false }
]

export default YesNoChoices
